import { render, staticRenderFns } from "./rule-config-folder.vue?vue&type=template&id=1efd37d1"
import script from "./rule-config-folder.vue?vue&type=script&lang=js"
export * from "./rule-config-folder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports